export default {
    csManagement: {
        page: {
            title: 'CS管理センター',
            description: 'テナントクォータ、プロジェクト総数、Token消費の管理',
        },
        quota: {
            searchPlaceholder: 'テナントIDで検索',
            typePlaceholder: 'クォータタイプ',
            search: '検索',
            create: 'クォータ追加',
            tenantId: 'テナントID',
            quotaType: 'クォータタイプ',
            typeDocument: 'プロジェクト総数',
            typeToken: 'Token消費総量',
            quotaLimit: '上限',
            quotaUsed: '使用済み',
            contractPeriod: '契約期間',
            contractStart: '契約開始',
            contractEnd: '契約終了',
            status: 'ステータス',
            statusActive: '有効',
            statusExpired: '期限切れ',
            remark: '備考',
            action: '操作',
            edit: '編集',
            delete: '削除',
            createTitle: 'クォータ追加',
            editTitle: 'クォータ編集',
            cancel: 'キャンセル',
            confirm: '確認',
            saving: '保存中...',
            featureConfig: '機能設定',
            featureConfigTitle: '機能権限設定',
            featureQuotaSectionTitle: 'プロジェクトタイプ別上限',
            featureQuotaSectionDesc: '契約期間中に各タイプで作成できるプロジェクト数を設定します。-1 は無制限、0 は機能無効を表します。',
            featureDisclosure: '発明開示書',
            featureDisclosureLimit: '発明開示書プロジェクト上限',
            featureDisclosureDesc: '発明開示書プロジェクト',
            featurePatentDraft: '特許出願',
            featurePatentDraftLimit: '特許出願プロジェクト上限',
            featurePatentDraftDesc: '特許出願プロジェクト',
            featureProsecution: 'OAR応答',
            featureProsecutionLimit: 'OAR応答プロジェクト上限',
            featureProsecutionDesc: '審査意見応答プロジェクト',
            featureLimitHint: '* -1 は無制限、0 は機能無効を表します',
            featureLimitExceeded: 'プロジェクトタイプ別上限の合計 {total} は会社のプロジェクト上限 {limit} を超えられません',
            userAllocationExceeded: 'プロジェクトタイプ別割り当ての合計（{total}）が会社のプロジェクト上限（{limit}）を超えています。調整してください。',
            featureUsed: '使用済み',
            featureRemaining: '残り',
            featureReachedLimit: '上限に達しました',
            featureLimitBelowUsedWarning: '上限が使用済みプロジェクト数を下回っています',
            featureDisabled: '無効',
            userQuotaTitle: 'ユーザープロジェクトクォータ詳細',
            userQuotaHint: '会社プロジェクト上限：{limit} 件',
            userEmail: 'ユーザーメール',
            unlimited: '無制限',
            addUser: 'ユーザー追加',
            addUserPlaceholder: 'メールアドレスを入力',
            reset: 'クリア',
            deleteUserQuotaConfirmTitle: 'このユーザーの個人クォータ設定を削除しますか？',
            deleteUserQuotaConfirmDesc: '削除後、このユーザーはユーザープロジェクトクォータ詳細に表示されず、個人のプロジェクトタイプ別上限は未設定の状態に戻ります。',
            tenantName: '会社名',
            configuredMembers: '設定済みメンバー',
            noConfiguredMembers: 'この会社には設定済みメンバーがいません',
            tenantInfoNotFound: '会社が見つかりません',
            tenantInfoFailed: '取得に失敗しました。後でもう一度お試しください',
            featureList: '機能一覧',
            featureAll: 'すべて',
        },
    },
};
